<div class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        Goods Receipt
        <div class="pull-right">
            <button nz-button class="pf-form-action" (click)="Update()">
                <span class="fa-solid fa-floppy-disk"></span>Save
            </button>
        </div>
    </div>
    <div class="panel-body">
        @if (PO.ContactInformation) {
            <div class="panel panel-default">
                <div class="panel-heading">Shipping Information</div>
                <div class="panel-body">
                    <div role="form" class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To Address 1</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToAddressLine1"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Address 2</div>
                            <div class="col-md-4">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToAddressLine2"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To City</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToCity"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To State</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToState"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To ZIP</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToZip"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2 control-label">Ship To Email</div>
                            <div class="col-md-2">
                                <input
                                    type="email"
                                    [(ngModel)]="PO.ContactInformation.ShipToEmail"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Phone</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToPhone"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                            <div class="col-md-2 control-label">Ship To Fax</div>
                            <div class="col-md-2">
                                <input
                                    type="text"
                                    [(ngModel)]="PO.ContactInformation.ShipToFax"
                                    [ngModelOptions]="{standalone: true}"
                                    class="form-control"
                                    readonly="readonly" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">Receipt Notes</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">EQUIP PO #</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [(ngModel)]="PO.DBSPONumber"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Receipt Notes</div>
                        <div class="col-md-10">
                            <textarea
                                class="form-control"
                                [(ngModel)]="PO.ReceiptNotes"
                                [ngModelOptions]="{standalone: true}"
                                style="height: 100px; width: 100%"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">
                Line Items
                <div class="pull-right">
                    <button
                        type="button"
                        class="btn btn-default"
                        style="padding: 2px 4px; margin-top: -2px"
                        (click)="MarkAllReceived()">
                        <span class="fa-solid fa-check"></span>&nbsp;Mark All Received
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Total</th>
                            <th># Received</th>
                            <th># Missing</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of PO.LineItems; track item) {
                            <tr [ngClass]="GetItemClass(item)">
                                <td>{{ item.Description }}</td>
                                <td>{{ item.Quantity }}</td>
                                <td>{{ item.Price | currency }}</td>
                                <td>{{ item.Price * item.Quantity | currency }}</td>
                                <td>
                                    <input
                                        style="max-width: 100px; text-align: center"
                                        class="form-control"
                                        step="1"
                                        type="number"
                                        [(ngModel)]="item.Received"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    {{ item.Quantity - item.Received }}
                                    @if (item.Quantity === item.Received) {
                                        <span>&nbsp;<span class="fa-solid fa-check"></span></span>
                                    }
                                    @if (item.Quantity !== item.Received) {
                                        <span title="This item was not entirely received."
                                            >&nbsp;<span class="fa-solid fa-triangle-exclamation"></span
                                        ></span>
                                    }
                                </td>
                            </tr>
                        }
                        <tr style="border-top: 2px double black">
                            <td><b>TOTAL</b></td>
                            <td></td>
                            <td></td>
                            <td>
                                <b>{{ GetLinesItemTotal() | currency }}</b>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
